module.exports = __webpack_public_path__ + "media/images/hero-mobile-2025-d8863c912e4530703d4e52bad83452ec.jpg";